import './ourServiceSection.scss';
import closetImage from '../../images/closet_image.png';
import gardenImage from '../../images/garden_image.png';
import weldingImage from '../../images/welding_image.png';
import plumbingImage from '../../images/plumbing_image.png';
import paintingImage from '../../images/painting_image.png';
import carpentryImage from '../../images/carpentry_image.png';
import applianceImage from '../../images/appliance_image.png';
import landscapeImage from '../../images/landscape_image.png';
import electricalImage from '../../images/electrical_image.png';

export const OurServiceSection = () => {
  const services: Array<{ image: string; name: string; displayText: string; alt: string }> = [
    {
      image: carpentryImage,
      name: 'carpentry',
      displayText: 'Carpentry & Roofing',
      alt: '',
    },
    {
      image: closetImage,
      name: 'closet',
      displayText: 'Closet Organizer Installation',
      alt: '',
    },
    {
      image: applianceImage,
      name: 'appliance',
      displayText: 'Appliance Installation',
      alt: '',
    },
    {
      image: landscapeImage,
      name: 'landscape',
      displayText: 'Gardening & Landscaping',
      alt: '',
    },
    { image: paintingImage, name: 'painting', displayText: 'Painting', alt: '' },
    { image: plumbingImage, name: 'plumbing', displayText: 'Plumbing', alt: '' },
    { image: electricalImage, name: 'electrical', displayText: 'Electrical', alt: '' },
    {
      image: weldingImage,
      name: 'welding',
      displayText: 'Welding & Metal Fabrication',
      alt: '',
    },
    { image: gardenImage, name: 'garden', displayText: 'Gardening', alt: '' },
  ];

  return (
    <div className={'our-services'} id={'services'}>
      <span id={'section-heading'}>Our Services</span>
      <div className={'our-services__top'}>
        <div className={'our-services__top__left'}>
          <h1>
            Whatever you’re Looking for, We Got You <span>Covered!</span>
          </h1>
        </div>
        <div className={'our-services__top__right'}>
          <p>
            We would love the opportunity to earn your trust through open communication, ontime performance,
            quality service and a price that keeps money in your wallet.
          </p>
          <button>See More</button>
        </div>
      </div>

      <div className={'our-services__bottom'}>
        {services.map(({ image, name, displayText, alt }, index) => (
          <div className={['our-services__bottom__service', name].join(' ')} key={name + index}>
            <img src={image} alt={alt} />
            <div className={'our-services__bottom__service__content'}>
              <span>{displayText}</span>
              <svg
                width="30px"
                height="30px"
                viewBox="0 0 24 24"
                fill="white"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4 12H20M20 12L16 8M20 12L16 16"
                  stroke="#FFFFFF"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
